module.exports = __webpack_public_path__ + "static/media/obv-logo-large-text.1c0383d9.svg";